module.exports = __webpack_public_path__ + "zarustajici-nehty_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/obecna-a-zilni-chirurgie/zarustajici-nehty_1_after_tn.jpg
// module id = 1505
// module chunks = 0